module.exports = __webpack_public_path__ + "img/2.5a50c900.jpg";